/* eslint camelcase: 0 */
import { toTalkerProps } from './talker'
import { Room, RoomRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IRoomProps, EmptyRoomPropsFactory } from '@/entities/Room'

export const toRoomProps = (props: Room | null | undefined): IRoomProps => {
  if (!props) {
    return EmptyRoomPropsFactory()
  }

  const {
    id,
    owner,
    unread_count,
    users,
    doctors,
    parents,
    owner_id,
    owner_type,
    user_title,
    enabled,
    latest_at,
    properties,
    created_at,
    updated_at,
    is_lite_only
  } = props

  return EmptyRoomPropsFactory({
    id,
    owner,
    unreadCount: unread_count || 0,
    users: users?.map((props) => toTalkerProps(props, 'user')),
    doctors: doctors?.map((props) => toTalkerProps(props, 'doctor')),
    parents: parents?.map((props) => toTalkerProps(props, 'parent')),
    ownerId: owner_id,
    ownerType: owner_type,
    userTitle: user_title,
    enabled,
    latestAt: latest_at,
    properties,
    createdAt: created_at,
    updatedAt: updated_at,
    isLiteOnly: is_lite_only
  })
}

export const toRoomRequest = (props: IRoomProps): RoomRequest => {
  const { doctor, room } = props

  return {
    room,
    doctor
  }
}
